export const externalLinks: Record<string, string> = {
  youTube: 'https://www.youtube.com/embed/eXMM9pnP0tc',
  youTubeChannel: 'https://www.youtube.com/channel/UCsdy3wI2zjdn5gXHpDUZocA',
  linkedin: 'https://www.linkedin.com/company/ailivesim',
  googleDoc:
    'https://docs.google.com/forms/d/1MFs2d85JAOqR_stRUyQPzAEKlqZZCHw1L1nFNii2TjQ/edit#responses',
};

export const resources: Record<string, string> = {
  assetsBucket: 'https://ailivesim.com/assets_23',
};
